import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props { total: number; afterRot: number; rot: number; previousTotal: number; valid?: boolean; }

/** Always accompanies the save action; changes remain visible while editing. */
export default function MilestoneAmountSummary({ total, afterRot, rot, previousTotal, valid = true }: Props) {
  const { t, i18n } = useTranslation();
  const format = (amount: number) => Number.isFinite(amount) ? new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'SEK', maximumFractionDigits: 2 }).format(amount) : '–';
  const change = (Math.round(total * 100) - Math.round(previousTotal * 100)) / 100;
  return <div className={`milestone-amount-summary w-100 border rounded p-2 mb-2 ${change !== 0 ? 'border-primary bg-light' : ''}`} data-testid="milestone-contract-amount-summary" role="status" aria-live="polite" aria-atomic="true">
    <div className="d-flex flex-wrap justify-content-between align-items-baseline gap-2">
      <strong>{t('milestones.form.contractAfterSave')}</strong>
      <strong className="fs-5">{format(total)}</strong>
    </div>
    <div className="d-flex flex-wrap justify-content-between gap-1 small mt-1">
      <span>{t('milestones.pricing.previousTotal', { amount: format(previousTotal) })}</span>
      <strong className={change !== 0 ? 'text-primary' : ''}>{t('milestones.form.contractTotalChange', { amount: `${change > 0 ? '+' : ''}${format(change)}` })}</strong>
    </div>
    <div className="d-flex flex-wrap justify-content-between gap-2 small mt-2">
      <span>{t('contracts.form.rot.afterRot')}: {format(afterRot)}</span>
      <span>{t('contracts.form.rot.planned')}: {valid ? format(rot) : '–'}</span>
    </div>
  </div>;
}
